import { Button, Row } from "@commonlibs";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";

export interface DatePickerFooterProps {
    className?: string;
    handleReset?: () => void;
    handleApply?: () => void;
}

export default function DatePickerFooter({ className, handleApply, handleReset }: DatePickerFooterProps) {
    const translate = useTranslate();

    return (
        <Row className={clsx("date-picker-footer", className)} justifyContent="space-between">
            <Button variant="danger" size="sm" onClick={handleReset}>
                {translate("reset")}
            </Button>
            <Button variant="secondary" size="sm" onClick={handleApply}>
                {translate("apply")}
            </Button>
        </Row>
    );
}
